import * as React from 'react';
import { unstable_createCssVarsProvider, unstable_prepareCssVars, styled } from '@mui/system';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/system": { unstable_createCssVarsProvider, unstable_prepareCssVars, styled } } } });
export default ClientProvider;
